import { Datagrid, InfiniteList, TextField, useRefresh } from "react-admin"
import CustomerFilters from "./CustomerFilters"
import { HubConnection } from "@microsoft/signalr"
import CustomerListActions from "./CustomerListActions"

interface IProps {
  connection?: HubConnection
}

const CustomerList = ({connection} : IProps) => {

  const refresh = useRefresh()

  connection?.on('CustomerUpdated', () => { refresh() })

  return (
    <InfiniteList filters={CustomerFilters} actions={<CustomerListActions />} sort={{field: "company.companyName", order: "ASC"}} >
      <Datagrid rowClick="show">
        <TextField source="company.companyName" label="resources.company.companyName" sortable={false} />
        <TextField source="company.email" label="resources.company.email" sortable={false} />
        <TextField source="company.postCode" label="resources.company.postCode" sortable={false} />
        <TextField source="company.city" label="resources.company.city" sortable={false} />
        <TextField source="company.country" label="resources.company.country" sortable={false} />
        <TextField source="ustId" sortable={false} />
      </Datagrid>
    </InfiniteList>
  )
}

export default CustomerList